import { WarningMessage } from '@common/components';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import useTranslation from '@/hooks/useTranslation';

interface ConfirmMarkCompleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  conversationCount: number;
  hasInProgressConversations: boolean;
  isLoading?: boolean;
  maxSelectionExceeded?: boolean;
}

export default function ConfirmMarkCompleteModal({
  isOpen,
  onClose,
  onConfirm,
  conversationCount,
  hasInProgressConversations,
  isLoading = false,
  maxSelectionExceeded = false,
}: ConfirmMarkCompleteModalProps) {
  const { lang } = useTranslation();

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="sm:max-w-[425px]">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            {lang.get('msg.confirmMarkComplete')}
          </AlertDialogTitle>
          <AlertDialogDescription className="flex flex-col gap-2 text-dark-text">
            {lang.get('msg.areYouSureYouWantToMarkAsComplete')} {conversationCount}{' '}
            {lang.get(`msg.conversation${conversationCount > 1 ? 's' : ''}`).toLowerCase()}{' '}
            {lang.get('msg.asComplete')}?
          </AlertDialogDescription>
        </AlertDialogHeader>

        <WarningMessage>
          <div>
            {maxSelectionExceeded
              ? lang.get('msg.markCompleteMaxSelectionWarning')
              : lang.get('msg.markCompleteWarning')}
            {!maxSelectionExceeded && hasInProgressConversations && (
              <span className="block mt-2 font-medium">
                {lang.get('msg.markCompleteInProgressWarning')}
              </span>
            )}
          </div>
        </WarningMessage>

        <AlertDialogFooter className="mt-5">
          <AlertDialogCancel onClick={onClose} disabled={isLoading}>
            {lang.get('msg.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isLoading || maxSelectionExceeded}>
            {lang.get('msg.markAsComplete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
